import React from "react";
import { motion, useReducedMotion } from "framer-motion";
const ease = [0.23, 1, 0.32, 1] as const;
const justify = {
  center: "justify-center",
  left: "justify-center lg:justify-start",
  right: "justify-center lg:justify-end"
};
interface SlideTitleProps {
  lines: string[];
  active: boolean;
  heading?: boolean;
  align: keyof typeof justify;
  className: string;
}

/** Display headline whose letters rise into place each time the slide becomes active. */
export function SlideTitle({
  lines,
  active,
  heading,
  align,
  className
}: SlideTitleProps) {
  const reduce = useReducedMotion();
  const Tag = heading ? "h1" : "p";
  return <Tag className={`font-display uppercase leading-[1.04] tracking-tight text-ink ${className}`} data-id="element-450" data-mp="3enkvj6cd2kla">
      <span className="sr-only" data-id="element-451" data-mp="39q2jh731rp92">{lines.join(" ")}</span>
      {lines.map((line, li) => <span key={line} aria-hidden="true" className={`flex overflow-hidden pb-[0.04em] ${justify[align]}`} data-id="element-452" data-mp="1cvfyxhjx2z48" data-mpi={li}>
          {line.split("").map((ch, ci) => <motion.span key={ci} className="inline-block whitespace-pre" initial={reduce ? false : {
        y: "105%"
      }} animate={{
        y: active || reduce ? "0%" : "105%"
      }} transition={{
        duration: 0.3,
        delay: active ? 0.1 + li * 0.12 + ci * 0.03 : 0,
        ease
      }} data-id="element-453" data-mp="3ogw0ncqgyh5t" data-mpi={ci}>
              {ch}
            </motion.span>)}
        </span>)}
    </Tag>;
}